<template>
  <div :class="$groupsStyle.enlargedContainer">
    <div :class="$groupsStyle.titleContainer">
      <div :class="$groupsStyle.titleText">{{ $t('all-groups-title') }}</div>
      <div :class="$groupsStyle.actionsContainer">
        <div title="View scoring criteria" :class="$groupsStyle.infoContainer" @click="openCalculationModal">
          <img :class="$groupsStyle.infoIcon" :src="calculatorIcon" alt="calculate" />
        </div>
        <div title="Close this box" :class="$groupsStyle.closeContainer" @click="props.closeAllGroupsLeaderboard">
          <img :class="$groupsStyle.closeIcon" :src="closeIcon" alt="close" />
        </div>
      </div>
    </div>
    <div :class="$groupsStyle.bodyContainer">
      <div v-for="(group, index) in props.groups" :key="index" :class="$groupsStyle.groupContainer">
        <LeaderboardBox
          :sortedPlayers="group.players"
          :isHost="props.isHost"
          :isGroupComponent="true"
          :title="getGroupDisplayName(group, index, t)"
        />
      </div>
    </div>

    <!-- Modal -->
    <CalculationModal v-if="showCalculationModal" :closeModal="closeCalculationModal" :bgClickClose="false" />
  </div>
</template>

<script setup>
// import styles from "@/css/AllGroupsLeaderboardBox.module.css";
// import globalStyles from "@/css/global.module.css";
import groupsStyles from "@/css/groupsUtil.module.css";
import CloseIcon from "@/assets/icons/close-red.svg";
import CalculatorIcon from "@/assets/icons/calculator.svg";
import CalculationModal from "./CalculationModal.vue";
import { ref } from "vue";
import LeaderboardBox from "./LeaderboardBox.vue";
import { getGroupDisplayName } from "@/utils/functions";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
// const $style = styles;
// const $globalStyle = globalStyles;
const $groupsStyle = groupsStyles;
const closeIcon = CloseIcon;
const calculatorIcon = CalculatorIcon;

const showCalculationModal = ref(false);

// eslint-disable-next-line
const props = defineProps({
  closeAllGroupsLeaderboard: {
    type: Function,
    required: true,
  },
  groups: {
    type: Array,
    required: true,
  },
  isHost: {
    type: Boolean,
    required: true,
  },
});

function closeCalculationModal() {
  showCalculationModal.value = false;
}

function openCalculationModal() {
  showCalculationModal.value = true;
}
</script>

<style scoped></style>
